/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionTypesControllerCreateMutationRequest, TemplateQuestionTypesControllerCreateMutationResponse, TemplateQuestionTypesControllerCreate400, TemplateQuestionTypesControllerCreate401, TemplateQuestionTypesControllerCreate403 } from "../../models/checklistsController/TemplateQuestionTypesControllerCreate";

function getTemplateQuestionTypesControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/checklist-template-question-types` as const }  
  return res
}

/**
 * @summary Create a new checklist template question type
 * {@link /api/v1/checklist-template-question-types}
 */
export async function templateQuestionTypesControllerCreate(data?: TemplateQuestionTypesControllerCreateMutationRequest, config: Partial<RequestConfig<TemplateQuestionTypesControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TemplateQuestionTypesControllerCreateMutationResponse, ResponseErrorConfig<TemplateQuestionTypesControllerCreate400 | TemplateQuestionTypesControllerCreate401 | TemplateQuestionTypesControllerCreate403>, TemplateQuestionTypesControllerCreateMutationRequest>({ method : "POST", url : getTemplateQuestionTypesControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}